import { createDropdownList } from '../inputs/DropdownListWithValueField';

export enum FlightProfileBackground {
    solid,
    dayNight,
    temperature
}

export const flightProfileBackgroundOptions = createDropdownList<FlightProfileBackground>()([
    { value: FlightProfileBackground.solid, text: 'Solid' },
    { value: FlightProfileBackground.dayNight, text: 'Day/night' },
    { value: FlightProfileBackground.temperature, text: 'Temperature', hidden: true }
]);
